import { useEffect } from 'react'
import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { useChatbotAnalyticContext } from 'pages/chatbot/pages/chatbotAnalytic/context/chatbotAnalyticContext'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'

export const ChatbotAnalyticAccessLayout = observer(() => {
  const { details } = useChatbotAnalyticContext()

  useEffect(() => {
    details.init()
  }, [])

  useEffect(() => {
    if (details.isAccessDenied) {
      uiStore.changeRouteViaVue({
        path: `/${ChatbotPath.all}`,
      })
    }
  }, [details.isAccessDenied])

  if (details.initialLoading) {
    return (
      <FullPageWrapper>
        <SpinnerLoader ariaLabel={'ChatbotAnalyticAccessLayout'} />
      </FullPageWrapper>
    )
  }

  if (details.isAccessDenied) return null

  return (
    <FullPageWrapper>
      <Outlet />
    </FullPageWrapper>
  )
})
